import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ApiService } from '../services/api.service';
import {DEFAULT_TABLE_PAGE_SIZE_OPTIONS} from '../shared/constants/pagination.constants';

type LoginEntry = {
  id: number;
  username: string;
  organization: string | null;
  role: string | null;
  last_login: string | null;
};

@Component({
    selector: 'app-login-activity',
    imports: [CommonModule, FormsModule],
    templateUrl: './login-activity.component.html',
    styleUrls: ['./login-activity.component.css']
})
export class LoginActivityComponent {
    readonly pageSizeOptions = DEFAULT_TABLE_PAGE_SIZE_OPTIONS;
  entries: LoginEntry[] = [];
  organizations: Array<{ id: string | number; name: string }> = [];
  selectedOrgId: string = '';
  loading = false;

  recordsPerPage = 25;
  currentPage = 1;
  totalRecords = 0;
  totalPages = 1;
  nextPage: string | null = null;
  previousPage: string | null = null;

  constructor(private apiService: ApiService) {}

  ngOnInit() {
    this.fetchOrganizations();
    this.fetchLoginActivity();
  }

  fetchOrganizations() {
    this.apiService.getOrganizations().subscribe((data: any) => {
      if (Array.isArray(data?.results)) {
        this.organizations = data.results;
        return;
      }
      if (data && typeof data === 'object') {
        this.organizations = Object.entries(data).map(([id, name]) => ({ id, name: String(name) }));
        return;
      }
      this.organizations = [];
    });
  }

  fetchLoginActivity() {
    this.loading = true;
    const orgId = this.selectedOrgId || null;
    this.apiService.getLoginActivity(this.currentPage, this.recordsPerPage, orgId).subscribe({
      next: (data: any) => {
        this.entries = data?.results ?? [];
        this.totalRecords = data?.count ?? 0;
        this.nextPage = data?.next ?? null;
        this.previousPage = data?.previous ?? null;
        this.totalPages = Math.max(1, Math.ceil(this.totalRecords / this.recordsPerPage));
        this.loading = false;
      },
      error: () => {
        this.entries = [];
        this.totalRecords = 0;
        this.totalPages = 1;
        this.loading = false;
      }
    });
  }

  onOrganizationChange() {
    this.currentPage = 1;
    this.fetchLoginActivity();
  }

  next() {
    if (this.nextPage) {
      this.currentPage += 1;
      this.fetchLoginActivity();
    }
  }

  previous() {
    if (this.previousPage) {
      this.currentPage -= 1;
      this.fetchLoginActivity();
    }
  }

  selectPageSize() {
    this.currentPage = 1;
    this.fetchLoginActivity();
  }

  refresh() {
    this.fetchLoginActivity();
  }
}
